<template>
    <div class="address-select-container">
        <el-tooltip class="item" effect="dark" :disabled="!tooltipList.length" :content="showStr" placement="top-start">
             <template slot="content">
                    <div v-for="(item, index) in tooltipList" :key="index">{{ item.join('，') }}</div>
            </template>
            <el-input
                v-model="showStr"
                :readonly="false"
                :disabled="disabled"
                :placeholder="label"
                clearable
                @clear="inputChange"
                @input="inputChange">
                <el-button slot="append" icon="el-icon-search" @click="onShow"></el-button>
            </el-input>
        </el-tooltip>

        <el-dialog
            class="address-select-dialog"
            :title="label"
            :visible.sync="dialogVisible"
            width="800px"
            :append-to-body="true"
            :before-close="handleClose">
            <div class="address-select-panel">
                <el-tooltip class="item" effect="dark" :content="tooltipText" placement="top-start">
                    <el-button
                        type="primary"
                        :disabled="disabled"
                        @click="handleSelectTag"
                        icon="el-icon-plus"></el-button>
                </el-tooltip>
                <el-button @click="handleReset" :disabled="disabled">重置</el-button>

                <AddressSelect
                    v-model="addressSelectVal"
                    ref="addressSelect"
                    :minLayers="minLayers"
                    :noSelectProvince="noSelectProvince"
                    :collapseTags="false"
                    :placeholder="'placeholder'"
                    :basicProps="basicProps"
                    @getAddress="getAddress"
                    @input="onInput"></AddressSelect>
                <div class="address-select-list">
                    <el-table :data="tagsList" highlight-current-row v-loading="loading" height="245" :border="false">
                        <el-table-column
                            v-for="column in tableConfig"
                            :key="column.prop"
                            :prop="column.prop"
                            :label="column.value"
                            :width="column.width"
                            :show-overflow-tooltip="true">
                            <template v-slot="{ row }">
                                <template v-if="column.type === 'select'">
                                    {{ dictFormat(row[column.prop], column.optionsKey, column.options) }}
                                </template>
                                <template v-else>{{ row[column.prop] }}</template>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="60">
                            <template slot-scope="scope">
                                <el-button
                                    class="deleteBtn"
                                    :disabled="disabled"
                                    @click="onDeleteDate(scope.$index)"
                                    size="small"
                                    type="text">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <div class="selected-num-content">
                    <span class="selected-num-label">已选：</span>
                    <span>{{ tagsList.length }}</span>
                </div>
                <div>
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" :loading="confirmLoading" :disabled="disabled" @click="onConfirm">
                    确 定
                </el-button>
                </div>
                
            </span>
        </el-dialog>
    </div>
</template>

<script>
import AddressSelect from './AddressSelectInner'
import _ from '@/components/lots/utils'
import ldash from 'lodash'
import { getSearchEbPlace } from '../../../../../../api/bidScheme.js'

const millisecond = 1000
const sixty = 60
const timeOfDay = 24
const tableConfig = [{ prop: 'label', value: '名称' }]

export default {
    props: {
        value: {
            type: Array,
            defalut() {
                return []
            },
        },
        noSelectProvince: {
            type: Boolean,
            default() {
                return false
            },
        },
        collapseTags: {
            type: Boolean,
            default() {
                return true
            },
        },
        label: String,
        label: String,
        basicProps: {
            type: Object,
            default() {
                return {}
            },
        },
        minLayers: {
            type: Number,
            default() {
                return 0
            },
        },
        placeholder: String,
        disabled: {
            type: Boolean,
            default() {
                return false
            },
        },
        clearable: {
            type: Boolean,
            default() {
                return true
            },
        },

        max: {
            type: Number,
            default: 0,
        },
        difference: {
            type: Number,
            default() {
                return millisecond * sixty * sixty * timeOfDay // 默认24小时
            },
        },
        areaUrl: {
            type: String,
            default() {
                return ''
            },
        },
    },
    data() {
        const _this = this
        return {
            tooltipList: [],
            dialogVisible: false,
            loading: false,
            confirmLoading: false,
            addrList: [],
            tableConfig,
            tagsObj: {},
            addrValue: [],
            addressSelectVal: [],
            showStr: '',
            tagsList: [
                // {
                //     label: '佛山市',
                //     value: '1',
                // },
            ],

            LEAF_INDEX: 4,
            AREA_TYPE: ['PLACE_PROVINCE', 'PLACE_CITY', 'PLACE_DISTRICT', 'PLACE_STREET'],
            addressArr: [],
            addressOptions: [],
            AREA_MAP: new Map(),
        }
    },
    components: { AddressSelect },
    methods: {
        chunkArray(array, chunkSize) {
            return Array.from({ length: Math.ceil(array.length / chunkSize) }, (_, index) =>
                array.slice(index * chunkSize, index * chunkSize + chunkSize),
            )
        },
        inputChange() {
            this.$emit('input', '')
            this.$emit('change', '')
            this.showStr = ''
            this.tagsList = []
            this.tooltipList = []
            this.addrValue = []
        },
        getAddress(val) {
            // console.log('val33',val);
        },
        onShow() {
            this.dialogVisible = true
        },
        handleSelectTag() {
            this.addressSelectVal = []
            this.$nextTick(() => {
                this.$refs.addressSelect.addressArr = []
                this.$refs.addressSelect.toggleExpand()
            })
        },
        hasValue(item) {
            let flag = false
            let currenVal = item.value
            for (let i = 0; i < this.tagsList.length; i++) {
                const row = this.tagsList[i]
                if (row.value === currenVal) {
                    flag = true
                    break
                }
            }
            return flag
        },
        onInput(val) {
            // console.log('onInput-val', val)
            // console.log('taglist', this.tagsList)

            if (!val.length) {
                return
            }

            for (const item of val) {
                let flag = this.hasValue(item)
                if (this.tagsList.length + 1 > this.max && this.max !== 0) {
                    this.$message.warning(`最多选择${this.max}个`)
                    return false
                }
                if (!flag) {
                    this.tagsList.unshift(item)
                }
            }

            // console.log('addrValue', this.addrValue);
            // this.addrValue = val;
            // this.tagsList = val

            // this.addrValue.push(item)
            // for (const item of val) {
            //     let flag = this.hasValue(item)
            //     if (this.addrValue.length + 1 > this.max && this.max !== 0) {
            //         this.$message.warning(`最多选择${this.max}个`)
            //         return
            //     }
            //     if (!flag) {
            //         this.addrValue.push(item)
            //     }
            // }

            // this.addrValue =this.addrValue.concat(val)
        },
        onConfirm() {
            // let strList = []
            // if (this.addrValue.length > this.max && this.max !== 0) {
            //     this.$message.warning(`最多选择${this.max}个`)
            //     return
            // }
            // let newDataList = ldash.cloneDeep(this.addrValue)
            // for (const itemList of newDataList) {
            //     let strItem = ''
            //     if (Array.isArray(itemList)) {
            //         strItem = itemList.join('-')
            //         strList.push(strItem)
            //     }
            // }
            // let strValue = strList.join(',')

            // this.$emit('input', strValue)
            // this.$emit('change', strValue)
            this.$emit('input', this.tagsList)
            this.$emit('change', this.tagsList)

            this.dialogVisible = false
        },
        handleClose() {
            this.dialogVisible = false
        },
        handleReset() {
            let val = ldash.cloneDeep(this.value)
            this.tagsList = val
            // let pList = []
            // if (typeof val == 'string') {
            //     let strList = val.split(',')

            //     let innerList = []
            //     for (const str of strList) {
            //         let strlist2 = str.split('-')
            //         pList.push(strlist2)
            //     }
            // }

            // this.addressArr = val
            // this.addrList = []
            // this.addrValue = pList
            // this.init(pList, 'init')
        },
        handleInputTagClose() {},

        onDeleteDate(index) {
            if (Array.isArray(this.tagsList)) {
                this.tagsList.splice(index, 1)
            }
            if (Array.isArray(this.addrValue)) {
                this.addrValue.splice(index, 1)
            }
        },
        optionsFormat(item, isLeaf) {
            return {
                label: item.ebplNameCn,
                value: item.ebplCode,
                leaf: isLeaf,
            }
        },
        disabledRadio(level) {
            // 只有选择任意级的时候才需要对radio禁用
            if (this.basicProps.checkStrictly) {
                this.$nextTick(() => {
                    if (this.$refs.cascader.panel.$el.getElementsByClassName('el-cascader-menu__list')[level]) {
                        const menuListDom =
                            this.$refs.cascader.panel.$el.getElementsByClassName('el-cascader-menu__list')[level]
                        menuListDom.className = menuListDom.className.replace(' disable-radio', '') + ' disable-radio'
                    }
                })
            }
        },
        setVal(value) {
            let allList = []
            for (const item of value) {
                allList.push(item.label)
            }
            this.showStr = allList.join(',')
            this.tooltipList = this.chunkArray(allList, 10)
        },
        async init(value, type) {
            // const rootNodes = await this.getArea1(100000, [], 0)
            // console.log('rootNodes777', rootNodes)

            // let newList = []
            // for (const item of value) {
            //     let currentIndex = item.length - 2

            //     let flag = this.findData(newList, item, currentIndex)
            //     if (flag) {
            //         newList.push(item)
            //     }
            // }
            // console.log('newList', newList)
            // this.addressOptions = await this.buildData(value)
            let data = await this.buildData(value)
            // console.log('nodes11111111111110000', this.addrList)
            if (Array.isArray(value)) {
                let allList = []
                let showStr = ''
                for (const itemList of value) {
                    if (Array.isArray(itemList)) {
                        let row = {
                            label: '',
                            value: '',
                        }
                        let labelStr = ''
                        for (let i = 0; i < itemList.length; i++) {
                            let item = itemList[i]
                            labelStr += this.tagsObj[item]
                        }
                        showStr += labelStr + ','
                        row.value = itemList.join(',')
                        row.label = labelStr

                        allList.push(row)
                    }
                }
                if (typeof showStr === 'string' && showStr.length > 0) {
                    showStr = showStr.substring(0, showStr.length - 1)
                }
                if (type === 'init') {
                    this.showStr = showStr
                }
                this.tagsList = allList
            }
        },
        // 获取地址列表
        async getArea1(ebplParentPmCode, addressArr, level) {
            // let ddrr={     {
            //         ebplParentPmCode,
            //         ebplType: this.AREA_TYPE[level],
            //     },
            //     this.difference,
            //     this.areaUrl,}
            // console.log('ebplParentPmCode', ebplParentPmCode)
            // console.log('addressArr', addressArr)
            // console.log('level', level)
            // console.log('ebplType', this.AREA_TYPE[level])
            // 根据地址的层级获取数据
            const res = await getSearchEbPlace({
                ebplParentPmCode: `${ebplParentPmCode}`,
                ebplType: this.AREA_TYPE[level],
                ebplIsAble: 'ENABLE',
            })
            if (res && res.code === '0') {
                const nodes = res.data.map(item => {
                    this.AREA_MAP.set(item.ebplCode, item.ebplNameCn)
                    return this.optionsFormat(item, level + 1 >= this.leafIndex)
                })
                // console.log('nodes', nodes)

                // // 获取当前选中的项被获取子地址列表
                // const nextNode = nodes.find(item => item.value === addressArr[level])
                // if (nextNode) {
                //     nextNode.children = await this.getArea(nextNode.value, addressArr, ++level)
                // }

                return nodes
            }
        },
        // 提供给外部的解析地址code的函数，入参：['code1', 'code2',...], 出参：['name1','name2',...]
        addressFormat(arr) {
            let result = []
            if (_.isArray(arr)) {
                result = arr.map(item => this.AREA_MAP.get(item))
            }
            return result
        },
        findNode(tree, predicate) {
            for (const node of tree) {
                if (predicate(node)) {
                    return node
                }
                if (node.children && node.children.length) {
                    const found = this.findNode(node.children, predicate)
                    if (found) return found
                }
            }
            return null
        },
        /**
         * 构建数据，获取当前层级的子级数据并递归获取下一级数据
         * @param {Array} loadList 当前层级数据
         * @returns {Array} 根节点数据
         */
        async buildData(loadList) {
            // 1. 获取当前层级的子级数据
            // const rootNodes = await this.getChildrenAPI(10000)
            // console.log('loadList', loadList)
            const rootNodes = await this.getArea1(100000, [], 0)

            // console.log('rootNodes======', JSON.stringify(rootNodes))
            // ['135', '13502', '1350213', '1350213005'],
            // ['135', '13502', '1350213', '1350213005'],

            // for (const loadInnerList of loadList) {
            for (let j = 0; j < loadList.length; j++) {
                let loadInnerList = loadList[j]
                if (Array.isArray(loadInnerList)) {
                    for (let i = 0; i < loadInnerList.length; i++) {
                        const loadItem = loadInnerList[i]
                        const level = i
                        if (i === 0) {
                            // 1级省
                            // console.log('iii', i, loadItem, loadInnerList)

                            if (this.tagsObj[loadItem]) {
                                continue
                            }
                            for (const rootNode of rootNodes) {
                                // console.log('j0-rootNode', rootNode, loadItem)
                                if (rootNode.value == loadItem) {
                                    if (!this.tagsObj[loadItem]) {
                                        this.tagsObj[loadItem] = rootNode.label
                                    }
                                    break
                                }
                            }
                        } else if (i === 1) {
                            // 2级市
                            let provinceVal = loadInnerList[0]
                            if (this.tagsObj[loadItem]) {
                                continue
                            }
                            const children = await this.getArea1(provinceVal, [], i)
                            if (Array.isArray(children)) {
                                for (const rootNode of children) {
                                    if (rootNode.value == loadItem) {
                                        if (!this.tagsObj[loadItem]) {
                                            this.tagsObj[loadItem] = rootNode.label
                                        }
                                        break
                                    }
                                }
                            }
                        } else if (i === 2) {
                            // 3级区
                            let cityVal = loadInnerList[1]
                            if (this.tagsObj[loadItem]) {
                                continue
                            }
                            const children = await this.getArea1(cityVal, [], i)
                            if (Array.isArray(children)) {
                                for (const rootNode of children) {
                                    if (rootNode.value == loadItem) {
                                        if (!this.tagsObj[loadItem]) {
                                            this.tagsObj[loadItem] = rootNode.label
                                        }
                                        break
                                    }
                                }
                            }
                        } else if (i === 3) {
                            // 4级街道
                            let districtVal = loadInnerList[2]
                            if (this.tagsObj[loadItem]) {
                                continue
                            }
                            const children = await this.getArea1(districtVal, [], i)
                            if (Array.isArray(children)) {
                                for (const rootNode of children) {
                                    if (rootNode.value == loadItem) {
                                        if (!this.tagsObj[loadItem]) {
                                            this.tagsObj[loadItem] = rootNode.label
                                        }
                                        break
                                    }
                                }
                            }
                        }
                    }
                }
                //             let childrenRoot = null
            }
            return this.tagsObj
        },
    },
    computed: {
        tooltipText() {
            let labeltext = ''
            if (this.label) {
                labeltext = '添加' + this.label
            }

            return labeltext
        },
        propsConfig() {
            return { ...this.basicProps, ...this.extendProps }
        },
        leafIndex() {
            return this.minLayers || this.LEAF_INDEX
        },
    },
    watch: {
        value: {
            handler(val) {
                if (val) {
                    // console.log('ccccvalue', val)
                    if (Array.isArray(val)) {
                        this.tagsList = ldash.cloneDeep(val)
                        this.setVal(val)
                    }

                    // let val2 = ldash.cloneDeep(val)
                    // let pList = []
                    // if (typeof val2 == 'string') {
                    //     let strList = val2.split(',')

                    //     let innerList = []
                    //     for (const str of strList) {
                    //         let strlist2 = str.split('-')
                    //         pList.push(strlist2)
                    //     }
                    // }

                    // this.addressArr = val2
                    // this.addrList = []
                    // this.addrValue = pList
                    // this.init(pList, 'init')
                }
                // else {
                //     this.addressArr = []
                // }
            },
            deep: true,
            immediate: true,
        },
        // addrValue: {
        //     handler(val) {
        //         if (val) {
        //             let val2 = ldash.cloneDeep(val)
        //             this.init(val2)
        //         }
        //     },
        //     immediate: true,
        // },
    },
}
</script>
<style lang="less">
.address-select-container {
    .el-table__fixed-right {
        &::before {
            display: none;
        }
    }
    .address-select-panel {
        background-color: #ffffff;
    }

    .address-select-list {
        .address-select-item {
            height: 22px;
            line-height: 22px;
            border-bottom: 1px solid #e0e0e0;
            &:hover {
                background-color: #aecaf5;
            }
        }
    }

}
.address-select-dialog{
    .selected-num-content{
        font-size: 13px;
        color: #666666;
        .selected-num-label{
            color: #00bcbf;
        }
    }
    .dialog-footer{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
